/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.airway-card {
  div ~ label {
    margin-top: variables.$gap-between-lists;
    &.no-margin-top {
      margin-top: 0;
    }
  }

  .oxygen-flow-row {
    justify-content: flex-start;
    align-items: center;

    .oxygen-flow {
      width: 100px;
    }
  }

  .intubation-row {
    margin-top: variables.$gap-between-lists;
    justify-content: flex-start;
    align-items: center;
    .intubation-size {
      width: 110px;
    }
  }

  .number-of-attempts {
    width: 150px;
    margin-top: 10px;
  }
}

// Can also appear in dropdowns outside of the card
.airway-card-unit {
  color: variables.$color-disabled;

  p {
    color: variables.$color-disabled;
  }
}
